import {Injectable} from '@angular/core';
import {Constantes} from "../constantes/constantes";

@Injectable({
  providedIn: 'root'
})
export class Utilerias {

    public obtenerPagina(inicio: number, size: number, total: number): number {
        if (inicio === 0 || inicio === undefined) {
            return 0;
        }

        let maxPage: number = total > 0 ? (total / size) : 0;
        const residuo: boolean = (total % size) > 0;
        maxPage = residuo ? (maxPage + 1) : maxPage;

        let numPagina: number = this.obtenerNumeroPagina(inicio, size);
        numPagina = this.validarNumeroPagina(maxPage, numPagina);
        return numPagina;
    }

    private obtenerNumeroPagina(inicio: number, size: number) {
        return inicio / size;
    }

    private validarNumeroPagina(maxPage: number, page: number): number {
        if (page < 0) {
            page = 0;
        }
        return page;
    }

    /**
     * Retorna TRUE si el objeto es valido
     * @param objeto
     */
    public validarObjecto(objeto: any): boolean {
        if (objeto === null || objeto === undefined) {
            return false;
        }
        return true;
    }

    /**
     * Valida si existe un código de error, generalmente establecido en response.pcodRetorno.
     * Retorna TRUE si contiene un código de error.
     * @param codigo
     */
    public isCodigoError(codigo: any): boolean {
        const numero = this.convertirANumero(codigo);
        if (numero < 0 || numero > 0) {
            return true;
        }
        return false;
    }

    /**
     * Método que convierte a número la cadena proporcionada, si ocurre un error regesa -1
     * @param valor // Cadena
     */
    convertirANumero(valor: string): number {
        if (valor != null && valor !== undefined && valor.trim() !== '') {
            if (Constantes.VACIO !== valor) {
                try {
                    const numero = Number(valor);
                    return Number.isNaN(numero) ? numero : -1;
                } catch (e) {
                    return -1;
                }
            }
        } else {
            return -1;
        }
    }

    /**
     * Función que elimina los blancos de una cadena
     * @param valor // Cadena
     */
    eliminarVacios(valor: string): string {
        if (valor !== undefined && valor !== null && valor.trim() !== '') {
            return valor.trim();
        } else {
            return null;
        }
    }

}
